import { createApi } from '../api';

export const baseApi = createApi();
